import StoragePage from "@pages/storage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/storage/")({
	component: StoragePage,
	staticData: {
		breadcrumbId: "page.storage.title",
		breadcrumbTitle: "Storage",
	},
});
